import { Flex, HStack, Link, Text, useToken } from '@chakra-ui/react';

import { CloseIcon } from '@chakra-ui/icons';
import { StarFilled } from '@/client/components/icons/ContinuIcons';
import { hexToRGBA } from '@/client/utils/hexToRGBA';
import { useTranslation } from 'react-i18next';

interface NewInstancesBannerProps {
  onHide: () => void;
}

export default function NewInstancesBanner({ onHide }: NewInstancesBannerProps) {
  const { t } = useTranslation();
  const [brandPrimary] = useToken('colors', ['brand.primary']);

  return (
    <Flex
      alignItems="center"
      background={`linear-gradient(90deg, #FFFFFF -46.17%, ${hexToRGBA(
        brandPrimary,
        1,
      )} 48.19%, #FFFFFF 161.19%)`}
      paddingY={2}
      paddingX={6}
      borderRadius="8px"
      marginTop={4}
    >
      <Flex width="5%" />

      <Flex flex={1} justifyContent="center">
        <HStack color="white">
          <StarFilled />

          <Text fontSize="16px" fontWeight={600}>
            {t('admin.assignments.details.instancesBanner.newTo')}{' '}
            <Link
              href="https://help.continu.com/hc/en-us/articles/32642640689175-Updated-Assignments-Article-Video-Hub"
              color="white"
              textDecoration="underline"
              _hover={{ color: 'white' }}
              isExternal
            >
              {t('admin.assignments.details.instancesBanner.readAbout')}
            </Link>{' '}
            {t('admin.assignments.details.instancesBanner.reuse')}
          </Text>
        </HStack>
      </Flex>

      <Flex width="5%" justifyContent="flex-end">
        <CloseIcon
          color="white"
          justifySelf="flex-end"
          _hover={{ cursor: 'pointer' }}
          onClick={onHide}
        />
      </Flex>
    </Flex>
  );
}
